import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createVNode as _createVNode } from "vue";
const _hoisted_1 = { class: "reload-form px-md sm:px-0 layout-column items-center w-full sm:w-[340px] md:w-[290px]" };
const _hoisted_2 = { class: "typography-headline-2 mb-sm text-center" };
const _hoisted_3 = { class: "typography-body-2-regular dark:text-outline-dark text-center mb-sm+" };
const _hoisted_4 = { class: "button-wrapper w-full layout-row gap-md justify-between" };
import { OrButtonV3 as OrButton, } from '@onereach/ui-components';
import { computed, onMounted, ref } from 'vue';
import { useRouter } from 'vue-router';
import { useAuthStore } from '@/stores/auth/auth';
import config from '../config';
import LoginContainer from '../layouts/LoginContainer.vue';
export default /*#__PURE__*/ _defineComponent({
    __name: 'NoRightsPage',
    setup(__props) {
        const router = useRouter();
        const authStore = useAuthStore();
        const sharedUrl = config.SHARED_URL;
        const loading = ref(false);
        const loadUsers = async () => {
            await authStore.loadUsers();
        };
        const availableUsers = computed(() => authStore.availableUsers);
        const isMultipleUser = computed(() => availableUsers.value.length > 1);
        const listUsers = () => {
            router.push('/multi-user/list-users?fromExpired');
        };
        const logoutUrl = computed(() => {
            const encodedRedirectPath = encodeURIComponent(`${window.location.origin}/#/`);
            return `${config.AUTH_UI_URL}/logout?redirectPath=${encodedRedirectPath}`;
        });
        const logout = () => {
            window.parent.location.href = logoutUrl.value;
        };
        const goToShared = () => {
            window.parent.location.href = sharedUrl;
            return false;
        };
        onMounted(async () => {
            if (!availableUsers.value.length) {
                loading.value = true;
                await loadUsers();
                loading.value = false;
            }
        });
        return (_ctx, _cache) => {
            return (_openBlock(), _createBlock(LoginContainer, {
                ref: "cookieExpireModal",
                class: "relogin-modal",
                background: true
            }, {
                default: _withCtx(() => [
                    _createElementVNode("div", _hoisted_1, [
                        _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t('session_expire.Permission denied')), 1),
                        _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('session_expire.You can switch to Shared app or sign in with another user account')), 1),
                        _createElementVNode("div", _hoisted_4, [
                            (isMultipleUser.value)
                                ? (_openBlock(), _createBlock(_unref(OrButton), {
                                    key: 0,
                                    loading: loading.value,
                                    class: "reload flex-1",
                                    variant: "outlined",
                                    onClick: listUsers
                                }, {
                                    default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$t('session_expire.Switch account')), 1)
                                    ]),
                                    _: 1
                                }, 8, ["loading"]))
                                : (_openBlock(), _createBlock(_unref(OrButton), {
                                    key: 1,
                                    loading: loading.value,
                                    class: "reload flex-1",
                                    variant: "outlined",
                                    onClick: logout
                                }, {
                                    default: _withCtx(() => [
                                        _createTextVNode(_toDisplayString(_ctx.$t('session_expire.Sign out')), 1)
                                    ]),
                                    _: 1
                                }, 8, ["loading"])),
                            _createVNode(_unref(OrButton), {
                                class: "reload flex-1",
                                onClick: goToShared
                            }, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.$t('session_expire.Shared app')), 1)
                                ]),
                                _: 1
                            })
                        ])
                    ])
                ]),
                _: 1
            }, 512));
        };
    }
});
